import styled from "styled-components";

export const Container = styled.div`
   display: flex;
   min-height: 100%;
   min-width: 100vw;
   position: relative;
`;

interface IMain{
    fullScreenMode: boolean;
}

export const Main = styled.main<IMain>`
    display: flex;
    align-items: center;
    flex-direction: column;
    flex: 1;
    position: relative;
    padding: 0 0 0.5rem 0;

    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    height: 100%;

    position: fixed;
    right: 0;
    width: calc(100% - var(--sidebar-width));

    ${(props) => props.fullScreenMode ? `
        padding: 0.5rem;
        width: 100% !important;
    `: ""};
`;

export const styledButton = `
	position: fixed;
	display: flex;
	align-items: center;
    bottom: 1.5rem;
    left: 1rem;
    z-index: 2000;
`;
